import type {ReactNode} from 'react';

export type TablePlaceholderProps = {
  text?: ReactNode;
  title?: ReactNode;
  iconSlot?: ReactNode;
  visible?: boolean;
  insideTable?: boolean;
  className?: string;
  children?: ReactNode | JSX.Element;
};

export function TablePlaceholder({
  children,
  text,
  title,
  className,
  visible,
  iconSlot,
  insideTable,
}: TablePlaceholderProps) {
  if (!visible) {
    return null;
  }

  const content = (
    <div className="flex flex-col items-center justify-center px-4 py-14 text-center">
      {iconSlot && <div className="mb-6">{iconSlot}</div>}
      {title && <h3 className="mb-2 text-lg font-semibold">{title}</h3>}
      {text && <p className="text-md max-w-sm font-medium">{text}</p>}
      {children && <div className="mt-6">{children}</div>}
    </div>
  );

  if (insideTable) {
    return (
      <tr>
        <td colSpan={100} className={className}>
          {content}
        </td>
      </tr>
    );
  }

  return <div className={className}>{content}</div>;
}
